import { readContract, writeContractAndWait } from "../viem";
import MafiaOGPremiumAbi from "../../abis/MafiaOGPremium.json";
import MafiaOGPremiumPLSAbi from "../../abis/MafiaOGPremiumPLS.json";
import config, { CHAIN } from "../../config/config";
import { ChainType } from "../../constants/enum/enum";
import { UserInfo } from "../../types/Contract/Premium/UserInfo";

const address = config.ogPremiumAddress;
const abi =
  CHAIN === ChainType.BNB ? MafiaOGPremiumAbi : MafiaOGPremiumPLSAbi;

export const buyPremium = async (account: string) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "buyPremium",
    account,
  });

  return data;
};

export const claimKeys = async (account: string) => {
  const data = await writeContractAndWait({
    address,
    abi,
    functionName: "claimKeys",
    account,
  });

  return data;
};

export const getUserInfo = async (account: string) => {
  const userInfo: UserInfo = await readContract({
    address,
    abi,
    functionName: "userInfos",
    args: [account],
  });
  const lastClaimedAt: number = await readContract({
    address,
    abi,
    functionName: "lastClaimedAt",
    args: [account],
  });

  return {
    userInfo: {
      startedAt: Number(userInfo.startedAt),
      expireAt: Number(userInfo.expireAt),
    },
    lastClaimedAt: Number(lastClaimedAt),
  };
};
